import { AnimatePresence } from 'framer-motion'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Icon from '@/components/Icon'
import Price from '@/components/Price'

import useCheckout from '../../hooks/useCheckout'
import { CartItemContent, CartItemImage, CartItemPrice, CartItemRemove, CartItemWrapper } from './Cart.styles'
import CartItemRemoveModal from './CartItemRemoveModal'

const CartItem = ({ product, destination, onProductAdd }) => {
  const { id, imageUrl, title, price, qty, oldPrice } = product
  const [showRemoveModal, setShowRemoveModal] = useState(false)
  const { removeFromCart } = useCheckout()
  const { addToCart } = useCheckout()
  const { t } = useTranslation()

  const handleAdd = () => {
    addToCart(product)
    if (onProductAdd) {
      onProductAdd()
    }
  }

  return (
    <>
      <CartItemWrapper key={id}>
        <CartItemImage>
          <img src={imageUrl} alt="" />
        </CartItemImage>
        <CartItemContent>
          <h4>{title}</h4>
          <span>{id}</span>
        </CartItemContent>
        <CartItemPrice>
          <span>{qty}x</span>
          <Price oldPrice={oldPrice}>{price}</Price>
        </CartItemPrice>
        {destination === 'delete' && (
          <CartItemRemove onClick={() => removeFromCart(product)}>
            <Icon name="trash" />
          </CartItemRemove>
        )}
        {destination === 'add' && (
          <CartItemRemove onClick={handleAdd}>
            <Icon name="plus" />
          </CartItemRemove>
        )}
      </CartItemWrapper>
      <AnimatePresence mode="wait">
        {showRemoveModal && <CartItemRemoveModal product={product} onClose={() => setShowRemoveModal(false)} />}
      </AnimatePresence>
    </>
  )
}

export default CartItem
